module.exports = __webpack_public_path__ + "img/43ne.66ad4fff.svg";